import React from 'react';
import {
	Container,
	EmptyExams,
	StatusIcon,
	Tooltip,
} from './ExamsResult.styles';
import { Paragraph } from '@welbe/web-design-system';
import { ExamsResultProps } from './ExamsResult.types';
import { ReactComponent as Calendar } from 'App/assets/img/calendarBlock.svg';
import { useExamsResult } from './ExamsResult.hooks';

export const ExamsResult = ({
	preventTooltip,
	exams,
	onClick,
}: ExamsResultProps) => {
	const {
		status,
		visible,
		position,
		statusEnums,
		resultAmount,
		containerRef,
		handleHover,
	} = useExamsResult({ exams });

	if (!exams.length)
		return (
			<EmptyExams id="empty-order-ids" data-testid="empty-order-ids">
				<Calendar width="18px" height="18px" />
				<Paragraph fontSize="13px" fontWeight="500" color="#d8dee6">
					Sin estudios agendados
				</Paragraph>
			</EmptyExams>
		);

	return (
		<Container
			ref={containerRef}
			id="container-order-ids"
			data-testid="container-order-ids"
		>
			<Tooltip
				visible={!preventTooltip && visible}
				position={position}
				correction={statusEnums[status].pixelCorrection}
			>
				{statusEnums[status].message}
			</Tooltip>
			<StatusIcon
				cursor={preventTooltip ? 'default' : 'pointer'}
				color={statusEnums[status].color}
				onMouseEnter={() => handleHover(true)}
				onMouseLeave={() => handleHover(false)}
			/>
			<Paragraph
				fontWeight="500"
				textDecoration="underline"
				cursor="pointer"
				onClick={onClick}
			>
				{resultAmount}
			</Paragraph>
		</Container>
	);
};
